var map = {
	"./2316003_ball_courts_football_sports_icon.svg": 38365,
	"./24-hours-delivery.svg": 51764,
	"./24-hours.svg": 20971,
	"./403.svg": 48442,
	"./404.svg": 55621,
	"./500.svg": 44416,
	"./503.svg": 89075,
	"./League of Legends.svg": 62833,
	"./add.svg": 49892,
	"./bet.svg": 95116,
	"./betslip.svg": 88854,
	"./casino.svg": 48806,
	"./comet-crash.svg": 64539,
	"./default_sport.svg": 15305,
	"./facebook-logo.svg": 52025,
	"./fav-casino.svg": 66230,
	"./fire.svg": 60995,
	"./football-stadium-svgrepo-com.svg": 12603,
	"./home.svg": 83130,
	"./hourglass-svgrepo.svg": 73374,
	"./icon.svg": 19584,
	"./instagram.svg": 56137,
	"./jackpot.svg": 41887,
	"./jet.svg": 54468,
	"./kenya.svg": 21009,
	"./opened-email-envelope.svg": 61076,
	"./padlock-dark.svg": 31956,
	"./padlock.svg": 70031,
	"./spaceman.svg": 63181,
	"./sports/American Football.svg": 81614,
	"./sports/Aussie Rules.svg": 80750,
	"./sports/Badminton.svg": 22349,
	"./sports/Baseball.svg": 64913,
	"./sports/Basketball.svg": 920,
	"./sports/Boxing.svg": 60200,
	"./sports/Cricket.svg": 79202,
	"./sports/Darts.svg": 55325,
	"./sports/Futsal.svg": 79858,
	"./sports/Gaerlic Hurling.svg": 31401,
	"./sports/Handball.svg": 45141,
	"./sports/Ice Hockey.svg": 75217,
	"./sports/MMA.svg": 60128,
	"./sports/MMA3.svg": 56483,
	"./sports/Motorsport.svg": 59962,
	"./sports/My Bets.svg": 6261,
	"./sports/Rugby.svg": 45674,
	"./sports/Soccer.svg": 47652,
	"./sports/Table Tennis.svg": 51796,
	"./sports/Tennis.svg": 15840,
	"./sports/Volleyball.svg": 83005,
	"./sports/Waterpolo.svg": 94046,
	"./sports/aviator.svg": 33389,
	"./sports/default_sport.svg": 52855,
	"./sports/eSoccer.svg": 46379,
	"./twitter-logo-on-black-background.svg": 3185,
	"./whatsapp.svg": 28965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57477;